/* swatch-nudge.js — Hydeline swatch-verification banner (Amax, 2026-07-31 v4).
 * Renders in the cart page AND the cart drawer (which re-renders via AJAX, hence the
 * MutationObserver re-init). Asks the Amax report server whether the customer already
 * requested swatches for the leather colors in the cart; if not, shows a nudge whose
 * "Send me free swatches" button opens a MODAL collecting name + phone + full shipping
 * address (prefilled for logged-in customers) — the CS team mails swatches from that email
 * alone (Kateryna 2026-07-31). Every failure path is silent — checkout is never blocked. */
(function () {
  "use strict";
  if (window.__amaxSwatchNudgeLoaded) return; // guard against double script tags
  window.__amaxSwatchNudgeLoaded = true;

  var LS_KEY = "amax_swatch_nudge_v1";
  var DONE_TTL = 14 * 24 * 3600 * 1000; // don't re-nag the same email+colors for 14 days

  var state = {};
  try { state = JSON.parse(localStorage.getItem(LS_KEY) || "{}"); } catch (e) {}
  function saveState() { try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {} }
  function fp(email, colors) { return (email || "anon") + "|" + colors.slice().sort().join(";"); }
  function isDone(email, colors) { var t = state[fp(email, colors)]; return t && Date.now() - t < DONE_TTL; }
  function markDone(email, colors) { state[fp(email, colors)] = Date.now(); saveState(); }

  function api(base, path, body) {
    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 5000);
    return fetch(base + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined,
    }).then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); });
  }

  var css =
    ".swatch-nudge{margin:14px 0;padding:14px 16px;border:1px solid #d9c9bc;border-radius:8px;background:#faf6f2;font-size:14px;line-height:1.5;color:#2c2c2d;text-align:left}" +
    ".swatch-nudge h4{margin:0 0 6px;font-size:15px;font-weight:600}" +
    ".swatch-nudge p{margin:0 0 10px}" +
    ".swatch-nudge .sn-colors{font-weight:600}" +
    ".swatch-nudge .sn-row{display:flex;gap:8px;flex-wrap:wrap}" +
    ".swatch-nudge .sn-go,.sn-modal .sn-go{padding:9px 16px;border:0;border-radius:6px;background:#8a6955;color:#fff;font-size:14px;font-weight:600;cursor:pointer}" +
    ".sn-modal .sn-go:disabled{opacity:.6;cursor:default}" +
    ".swatch-nudge .sn-dismiss{background:none;border:none;color:#8a6955;text-decoration:underline;font-weight:400;font-size:13px;padding:9px 4px;cursor:pointer}" +
    ".swatch-nudge .sn-ok{color:#3d6b45;font-weight:600;margin:0}" +
    ".swatch-nudge.sn-slim{margin:8px 0;padding:0}" +
    ".swatch-nudge .sn-teaser{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:9px 12px;cursor:pointer;font-size:13px;line-height:1.35}" +
    ".swatch-nudge .sn-teaser b{font-weight:600}" +
    ".swatch-nudge .sn-teaser .sn-cta{color:#8a6955;font-weight:600;white-space:nowrap}" +
    /* modal */
    ".sn-overlay{position:fixed;inset:0;background:rgba(30,24,20,.5);z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:16px}" +
    ".sn-modal{background:#fff;border-radius:12px;max-width:430px;width:100%;max-height:92vh;overflow:auto;padding:22px;font-family:inherit;font-size:14px;color:#2c2c2d;box-shadow:0 12px 40px rgba(0,0,0,.25);position:relative;text-align:left}" +
    ".sn-modal h3{margin:0 0 4px;font-size:17px;font-weight:700}" +
    ".sn-modal .sn-sub{margin:0 0 12px;font-size:13px;color:#6b5f54}" +
    ".sn-modal .sn-colors{font-weight:600}" +
    ".sn-modal .sn-x{position:absolute;top:10px;right:14px;border:none;background:none;font-size:22px;line-height:1;color:#a09488;cursor:pointer}" +
    ".sn-modal label{display:block;font-size:12px;color:#8a7a6c;margin:10px 0 3px}" +
    ".sn-modal input{width:100%;box-sizing:border-box;padding:9px 12px;border:1px solid #c9b8a9;border-radius:6px;font-size:14px;background:#fff}" +
    ".sn-modal .sn-grid{display:flex;gap:8px}" +
    ".sn-modal .sn-grid>div{flex:1;min-width:0}" +
    ".sn-modal .sn-actions{margin-top:16px}" +
    ".sn-modal .sn-go{width:100%}" +
    ".sn-modal .sn-err{color:#a04545;margin:8px 0 0;font-size:13px}" +
    ".sn-modal .sn-ok{color:#3d6b45;font-weight:600;font-size:15px;text-align:center;padding:20px 6px}";

  function ensureStyle() {
    if (document.getElementById("swatch-nudge-style")) return;
    var s = document.createElement("style");
    s.id = "swatch-nudge-style";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function hideAll() {
    var nodes = document.querySelectorAll(".swatch-nudge");
    for (var i = 0; i < nodes.length; i++) nodes[i].style.display = "none";
  }

  function successAll(zip) {
    var nodes = document.querySelectorAll(".swatch-nudge");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.remove("sn-slim");
      nodes[i].innerHTML = '<p class="sn-ok">✓ Free swatches on the way' + (zip ? " to " + esc(zip) : "") + "! Feel free to complete your purchase — checking the swatch before your furniture ships is exactly the idea.</p>";
      nodes[i].style.display = "block";
    }
  }

  // ── modal: name + phone + full shipping address (Kateryna 2026-07-31) ────
  function openModal(cfg, missingColors, knownEmail, allColors) {
    ensureStyle();
    var old = document.getElementById("sn-overlay");
    if (old) old.remove();
    var f = function (v) { return esc(String(v || "")); };
    var ov = document.createElement("div");
    ov.className = "sn-overlay";
    ov.id = "sn-overlay";
    ov.innerHTML =
      '<div class="sn-modal" role="dialog" aria-modal="true">' +
      '<button type="button" class="sn-x" aria-label="Close">×</button>' +
      "<h3>Free leather swatches</h3>" +
      '<p class="sn-sub">We’ll mail you <span class="sn-colors">' + missingColors.map(esc).join(", ") + "</span> — tell us where to send them.</p>" +
      '<label>Full name</label><input type="text" class="sn-name" autocomplete="name" value="' + f(cfg.customerName) + '">' +
      (knownEmail ? "" : '<label>Email</label><input type="email" class="sn-email" autocomplete="email">') +
      '<label>Phone</label><input type="tel" class="sn-phone" autocomplete="tel" value="' + f(cfg.phone) + '">' +
      '<label>Street address</label><input type="text" class="sn-addr" autocomplete="street-address" value="' + f([cfg.addr1, cfg.addr2].filter(Boolean).join(", ")) + '">' +
      '<div class="sn-grid">' +
      '<div><label>City</label><input type="text" class="sn-city" autocomplete="address-level2" value="' + f(cfg.city) + '"></div>' +
      '<div><label>State / Province</label><input type="text" class="sn-state" autocomplete="address-level1" value="' + f(cfg.province) + '"></div>' +
      '<div><label>ZIP / Postal</label><input type="text" class="sn-zip" autocomplete="postal-code" value="' + f(cfg.zip) + '"></div>' +
      "</div>" +
      '<div class="sn-actions"><button type="button" class="sn-go">Send my free swatches</button></div>' +
      '<p class="sn-err" style="display:none"></p>' +
      "</div>";
    document.body.appendChild(ov);

    // If a cart drawer is open (EComposer on prosperahome / any drawer with a close control),
    // close it first — its global click-outside/focus-trap handlers swallow modal interactions.
    try {
      var drawerClose = document.querySelector(".ecom-ajax-cart-close-button,[data-ecom-action=\"close\"]");
      if (drawerClose && drawerClose.offsetParent) drawerClose.click();
    } catch (e) {}

    var modal = ov.querySelector(".sn-modal");
    var err = ov.querySelector(".sn-err");
    var go = ov.querySelector(".sn-go");
    var close = function () { ov.remove(); };

    // All modal interaction is handled in the CAPTURE phase on the overlay itself and then
    // propagation stops — so host-page global listeners (drawer traps, popup managers) never
    // see events inside the modal. Default actions (input focus, typing) are unaffected.
    var onModalEvent = function (e) {
      if (e.type === "click") {
        var t = e.target;
        var hit = function (sel) { return t.closest && t.closest(sel); };
        if (t === ov || hit(".sn-x")) close();
        else if (hit(".sn-go")) submit();
      }
      e.stopPropagation();
    };
    ["click", "mousedown", "mouseup", "pointerdown", "pointerup", "touchstart", "touchend", "keydown", "keyup", "keypress", "focusin"].forEach(function (t) {
      ov.addEventListener(t, onModalEvent, true);
    });

    function submit() {
      var val = function (sel) { var el = ov.querySelector(sel); return el ? String(el.value || "").trim() : ""; };
      var email = knownEmail || val(".sn-email").toLowerCase();
      var name = val(".sn-name"), phone = val(".sn-phone"), addr = val(".sn-addr");
      var city = val(".sn-city"), stateV = val(".sn-state"), zip = val(".sn-zip");
      var problem = null;
      if (!name) problem = "Please enter your name.";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) problem = "Please enter a valid email address.";
      else if (!phone) problem = "Please enter your phone number.";
      else if (!addr || !city || !zip) problem = "Please fill in your full shipping address.";
      if (problem) { err.textContent = problem; err.style.display = "block"; return; }
      err.style.display = "none";
      go.disabled = true;
      go.textContent = "Sending…";

      var fullAddress = [addr, city, [stateV, zip].filter(Boolean).join(" "), cfg.country || ""].filter(Boolean).join(", ");
      var finish = function () {
        markDone(email, allColors);
        markDone("", allColors); // anonymous fingerprint too — drawer re-renders as guest
        modal.innerHTML = '<p class="sn-ok">✓ Free swatches on the way to ' + esc(zip) + "!<br>Feel free to complete your purchase.</p>";
        successAll(zip);
        setTimeout(close, 2500);
      };

      var flow;
      if (knownEmail) {
        flow = api(cfg.apiBase, "/request", { email: email, colors: missingColors, name: name, phone: phone, address: fullAddress, store: cfg.store || "" });
      } else {
        // Guest: their email might already have swatches on file — check before requesting.
        flow = api(cfg.apiBase, "/check", { email: email, colors: allColors, store: cfg.store || "" }).then(function (res) {
          var stillMissing = (res.results || []).filter(function (r) { return !r.hasSwatch; }).map(function (r) { return r.color; });
          if (!res.ok || !stillMissing.length) return; // already covered — just finish quietly
          return api(cfg.apiBase, "/request", { email: email, colors: stillMissing, name: name, phone: phone, address: fullAddress, store: cfg.store || "" });
        });
      }
      flow.then(finish).catch(function () { close(); hideAll(); }); // API failure: quietly disappear
    }
  }

  // ── banner states ────────────────────────────────────────────────────────
  function wireBanner(host, cfg, missingColors, knownEmail, allColors) {
    host.querySelector(".sn-go").addEventListener("click", function () {
      openModal(cfg, missingColors, knownEmail, allColors);
    });
    var d = host.querySelector(".sn-dismiss");
    if (d) d.addEventListener("click", function () {
      markDone(knownEmail || "", allColors);
      hideAll();
    });
  }

  // Full banner (cart page)
  function render(host, cfg, missingColors, knownEmail, allColors) {
    ensureStyle();
    host.classList.remove("sn-slim");
    host.innerHTML =
      "<h4>Have you seen this leather in person?</h4>" +
      '<p>Screen colors can vary from the real thing. Before we ship your furniture, let us send you a <strong>free leather swatch</strong> of <span class="sn-colors">' + missingColors.map(esc).join(", ") + "</span> so you can be confident it’s the perfect match.</p>" +
      '<div class="sn-row">' +
      '<button type="button" class="sn-go">Send me free swatches</button>' +
      '<button type="button" class="sn-dismiss">No thanks, I’ve seen the color</button>' +
      "</div>";
    host.style.display = "block";
    wireBanner(host, cfg, missingColors, knownEmail, allColors);
  }

  // Collapsed one-line teaser (cart drawer) — keeps the item list visible (Kateryna).
  // Tapping it opens the modal directly.
  function renderTeaser(host, cfg, missingColors, knownEmail, allColors) {
    ensureStyle();
    host.classList.add("sn-slim");
    host.innerHTML =
      '<div class="sn-teaser"><span><b>Have you seen this leather in person?</b> Get a free swatch before we ship.</span>' +
      '<span class="sn-cta">Free swatch ›</span></div>';
    host.style.display = "block";
    host.querySelector(".sn-teaser").addEventListener("click", function () {
      openModal(cfg, missingColors, knownEmail, allColors);
    });
  }

  function initOne(host) {
    var cfg;
    try { cfg = JSON.parse(host.getAttribute("data-config")); } catch (e) { return; }
    var colors = [];
    var seen = {};
    (cfg.colors || []).forEach(function (c) {
      c = String(c || "").trim().replace(/^(LC|FC)\s+/i, ""); // "LC 1868 Caramel" option label = same leather as "1868 Caramel"
      var key = c.toLowerCase();
      var code = (c.match(/\b(\d{3,4})\b/) || [])[1];
      if (code) key = code; // dedupe by color code when present
      if (c && !seen[key]) { seen[key] = 1; colors.push(c); }
    });
    if (!colors.length) return;

    var email = String(cfg.email || "").trim().toLowerCase();
    if (isDone(email, colors) || (!email && isDone("", colors))) return;

    var draw = cfg.compact ? renderTeaser : render; // drawer = collapsed teaser, cart page = full banner
    if (email) {
      api(cfg.apiBase, "/check", { email: email, colors: colors, store: cfg.store || "" })
        .then(function (res) {
          if (!res.ok || !res.ready) return;
          if (!res.anyMissing) { markDone(email, colors); return; }
          var missing = res.results.filter(function (r) { return !r.hasSwatch; }).map(function (r) { return r.color; });
          if (missing.length) draw(host, cfg, missing, email, colors);
        })
        .catch(function () {});
    } else {
      // Guest: no email to check against — show the nudge; the modal collects everything.
      draw(host, cfg, colors, null, colors);
    }
  }

  function scan() {
    var nodes = document.querySelectorAll(".swatch-nudge:not([data-sn-init])");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute("data-sn-init", "1");
      try { initOne(nodes[i]); } catch (e) {}
    }
  }

  // Initial + re-scan when the cart drawer re-renders via AJAX (debounced).
  var pending = null;
  function scheduleScan() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; scan(); }, 200);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
  }
})();
